import React from "react";

import { getCouponAddressVisibility } from "../utils";
import type { CouponTemplateContentProps } from "./types";
import { CouponTicket } from "./CouponTicket";
import { CouponHeader } from "./CouponHeader";
import { CouponAddress } from "./CouponAddress";
import { CouponTerms } from "./CouponTerms";
import { CouponSocialSection } from "./CouponSocialSection";

export const CouponTemplateContent = ({
  data,
  t,
  isInitialPreview,
  isFlipped,
  onFlip,
  onCloseFlip,
  addressData,
  dateStatus,
  hasLogo,
  buttonColor,
  backgroundColor,
  onCopyCode,
}: CouponTemplateContentProps) => {
  const {
    infoCompanyName,
    infoHeadline,
    infoDescription,
    infoSalesBadge,
    infoButtonText,
    couponName,
    couponTermsAndConditions,
    couponUrlLink,
    couponUrlText,
    locationAddress,
    logoUrl,
  } = data;

  const hasSocialNetworks = (data.socialNetworks?.length ?? 0) > 0;
  const isInitPreviewMode = isInitialPreview === true;

  const { showFrontAddress, showBottomAddress } = getCouponAddressVisibility(
    locationAddress,
    isFlipped,
    isInitialPreview
  );

  return (
    <div className="coupon-template">
      <CouponHeader companyName={infoCompanyName} />

      <CouponTicket
        isFlipped={isFlipped}
        hasLogo={hasLogo}
        buttonColor={buttonColor}
        backgroundColor={backgroundColor}
        logoUrl={typeof logoUrl?.[0]?.url === "string" ? logoUrl?.[0]?.url : undefined}
        isInitialPreview={isInitialPreview}
        infoSalesBadge={infoSalesBadge}
        infoHeadline={infoHeadline}
        infoDescription={infoDescription}
        infoButtonText={infoButtonText || t("preview_button_text")}
        promotionalCodeLabel={t("promotional_code")}
        couponName={couponName}
        couponUrlLink={couponUrlLink}
        couponUrlText={couponUrlText}
        dateStatus={dateStatus}
        copyButtonLabel={t("button_copy_label")}
        t={t}
        onFlip={onFlip}
        onClose={onCloseFlip}
        onCopyCode={onCopyCode}
      />

      {hasSocialNetworks && !isFlipped && (
        <CouponSocialSection
          data={data}
          isInitialPreview={false}
        />
      )}

      {showFrontAddress && (
        <CouponAddress
          fullAddress={addressData.fullAddress}
          addressMapsURL={addressData.addressMapsURL}
        />
      )}

      {couponTermsAndConditions && isFlipped && (
        <CouponTerms
          terms={couponTermsAndConditions}
          title={t("terms_and_conditions")}
        />
      )}

      {isInitPreviewMode && !hasSocialNetworks && (
        <CouponSocialSection
          data={data}
          isInitialPreview={true}
        />
      )}

      {hasSocialNetworks && isFlipped && (
        <CouponSocialSection
          data={data}
          isInitialPreview={false}
        />
      )}

      {showBottomAddress && (
        <CouponAddress
          fullAddress={addressData.fullAddress}
          addressMapsURL={addressData.addressMapsURL}
        />
      )}
    </div>
  );
};
